<template>
  <div id="default-layout">
    <div class="wrapper">
      <top-bar />
      <side-bar />
      <div class="content-page">
        <div class="content">
          <div class="container-fluid">
            <v-app id="app-bar">
              <!-- <page-title /> -->
              <router-view> </router-view>
            </v-app>
          </div>
        </div>
        <br/>
        <footer-menu />
      </div>
    </div>
    <theme-settings />
  </div>
</template>

<script>
import ThemeSettings from "@/components/ThemeSettings.vue";
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import FooterMenu from "@/components/FooterMenu.vue";
// import PageTitle from "@/components/PageTitle.vue";
export default {
  components: {
    ThemeSettings,
    TopBar,
    SideBar,
    FooterMenu,
    // PageTitle,
  },
  // data() {
  //   return {
  //     DisplayFlag: false,
  //   };
  // },
  // created() {
  //   window.addEventListener("resize", this.handleResize);
  //   this.handleResize();
  // },
  // methods: {
  //   handleResize() {
  //     console.log("handleResize called");
  //     var window_width = window.innerWidth;
  //     console.log({ window_width });
  //     this.DisplayFlag = window_width < 1141 ? false : true;
  //   },
  // },
};
</script>

<style lang="scss" scoped>
#default-layout {
  #app-bar {
    // background-color: #eaf1f3;
    margin-top: 20px;
  }
}
</style>